import React from "react";
import { Wrapper, LateralMenuContainer, Content, Container } from "./styled";
import LateralMenu from "./components/LateralMenu";

const MainLayout = (props) => {
  return (
    <Wrapper>
      <LateralMenuContainer>
        <LateralMenu />
      </LateralMenuContainer>
      <Container>
        <Content>{props.children}</Content>
      </Container>
    </Wrapper>
  );
};

export default MainLayout;
